<template>
  <v-app :class="lang" :lang="lang">
    <cpo-header />
    <div class="cpo-view">
      <router-view />
    </div>
    <cpo-footer />
  </v-app>
</template>

<script>
import CpoFooter from "./components/CpoFooter.vue";
import CpoHeader from "./components/CpoHeader.vue";
export default {
  components: { CpoHeader, CpoFooter },
  computed: {
    lang() {
      return this.$i18n.locale;
    }
  }
};
</script>

<style>
.cpo-view {
  min-height: calc(100vh - 150px);
}
</style>
